import { render, staticRenderFns } from "./BasketValidationMessage.vue?vue&type=template&id=612ddf0c"
import script from "./BasketValidationMessage.vue?vue&type=script&lang=js"
export * from "./BasketValidationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports